import React, { useState, useEffect, useCallback } from 'react'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router'
import { Container, Grid, TextField, Button } from '@material-ui/core'
import { Autocomplete, Box, Divider } from '@mui/material';
import { gcAPI } from './../services/GroupCategoryService'
import { userAPI } from "./../services/UserService"
import { Formik, Form } from "formik";
import * as Yup from "yup";

const Setting_Product = () => {
    const [allGroup, setAllGroup] = useState([])
    const [allCategory, setAllCategory] = useState([])
    const [allUser, setAllUser] = useState([])

    const findUser = useCallback((username) => {
        let find = allUser.find((res) => res.username == username)
        if (find) return find
        else return "-"
    }, [allUser])

    useEffect(() => {
        (async () => {
            try {
                const { status, message } = await gcAPI.getCategoryForCreate()
                if (!status == 200) throw { message }
                if (message.AllGroup instanceof Array) {
                    setAllGroup(message.AllGroup)
                }
                if (message.AllCategory instanceof Array) {
                    setAllCategory(message.AllCategory)
                }
                const user_api = await userAPI.getUserSetting()
                if (!user_api.status == 200) throw { message: user_api.message }
                if (user_api.message instanceof Array) {
                    setAllUser(user_api.message)
                }
            } catch (error) {
                alert(error.message)
            }
        })()

        return () => {
            setAllUser([])
            setAllGroup([])
            setAllCategory([])
        }
    }, [])

    let history = useHistory()

    const FormSchema = Yup.object().shape({
        Group: Yup.string()
            .trim()
            .required("*Group ห้ามว่าง"),
        Category: Yup.string()
            .trim()
            .required("*Category ห้ามว่าง"),
        Buyer: Yup.string()
            .trim()
            .required("*Buyer ห้ามว่าง"),
        Retail: Yup.string()
            .trim()
            .required("*Retail ห้ามว่าง"),
    });

    return (
        <Formik
            validationSchema={FormSchema}
            initialValues={{ Group: "", Category: "", Brand: "", Buyer: "", Retail: "" }}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
                try {
                    const { message, status } = await gcAPI.addCategory(values)
                    if (status != 200) throw { message }
                    Swal.fire({
                        icon: 'success',
                        confirmButtonColor: "#6ab23a",
                        html: `<span class="colorWhite">สร้าง Category สำเร็จต้องการไป /product เลยหรือไม่ ?</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switchZ'
                        },
                        width: '28rem',
                        showCancelButton: true,
                        confirmButtonColor: '#56A834',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ยืนยัน',
                        cancelButtonText: 'ยังก่อน',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            history.push("/product")
                        }
                        resetForm({ Group: "", Category: "", Brand: "", Buyer: "", Retail: "" })
                        setSubmitting(false)
                    })
                }
                catch (error) {
                    setSubmitting(false)
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 3000
                    })
                }
            }}
        >
            {({
                values,
                handleChange,
                setFieldValue,
                isSubmitting,
                touched,
                errors,
            }) => (
                <Form>
                    <Container style={{ padding: '20px', backgroundColor: '#ffffffbd', borderRadius: '10px' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <h3><strong>เพิ่มข้อมูล Product</strong></h3>
                            </Grid>
                        </Grid>
                        <Container style={{ paddingTop: '1rem' }}>
                            <div className="row">
                                <div className="pt-5 col-lg-12">
                                    <div className="row">
                                        {/* Group */}
                                        <div className="mt-4 col-lg-12">
                                            <Autocomplete
                                                options={allGroup}
                                                value={values.Group || null}
                                                onChange={(event, newValue) => {
                                                    setFieldValue("Group", newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Group..." variant="standard" onChange={(e) => setFieldValue("Group", e.target.value)} />
                                                )}
                                            />
                                            {errors.Group && touched.Group ? (
                                                <div style={{ color: "#FF3333" }}>{errors.Group}</div>
                                            ) : null}
                                        </div>
                                        {/* Category */}
                                        <div className="mt-4 col-lg-12">
                                            <Autocomplete
                                                options={allCategory}
                                                value={values.Category || null}
                                                onChange={(event, newValue) => {
                                                    setFieldValue("Category", newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Category..." variant="standard" onChange={(e) => setFieldValue("Category", e.target.value)} />
                                                )}
                                            />
                                            {errors.Category && touched.Category ? (
                                                <div style={{ color: "#FF3333" }}>{errors.Category}</div>
                                            ) : null}
                                        </div>
                                        {/* Brand */}
                                        <div className="mt-4 col-lg-12">
                                            <TextField
                                                style={{ width: '100%' }}
                                                name="Brand"
                                                value={values.Brand}
                                                label="Brand..."
                                                onChange={handleChange}
                                            />
                                            {errors.fullname && touched.fullname ? (
                                                <div style={{ color: "#FF3333" }}>{errors.fullname}</div>
                                            ) : null}
                                        </div>
                                        {/* Buyer */}
                                        <div className="mt-4 col-lg-12">
                                            <Autocomplete
                                                options={allUser || []}
                                                onChange={(e, v) => setFieldValue("Buyer", v?.username)}
                                                getOptionLabel={(op) => (op.fullname ? op.fullname : "")}

                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="เลือก Buyer"
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                            <Box style={{ margin: "10px 0", display: "flex" }}>
                                                ID: {findUser(values.Buyer) ? findUser(values.Buyer).username : "-"}{" "}
                                                <Divider
                                                    style={{ margin: "0 20px" }}
                                                    orientation="vertical"
                                                    flexItem
                                                />{" "}
                                                เบอร์โต๊ะ:  {findUser(values.Buyer) ? findUser(values.Buyer).table : "-"}
                                            </Box>
                                            {errors.Buyer && touched.Buyer ? (
                                                <div style={{ color: "#FF3333" }}>{errors.Buyer}</div>
                                            ) : null}
                                        </div>
                                        {/* Retail */}
                                        <div className="mt-4 col-lg-12">
                                            <Autocomplete
                                                options={allUser || []}
                                                onChange={(e, v) => setFieldValue("Retail", v?.username)}
                                                getOptionLabel={(op) => (op.fullname ? op.fullname : "")}

                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="เลือก Retail"
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                            <Box style={{ margin: "10px 0", display: "flex" }}>
                                                ID: {findUser(values.Retail) ? findUser(values.Retail).username : "-"}{" "}
                                                <Divider
                                                    style={{ margin: "0 20px" }}
                                                    orientation="vertical"
                                                    flexItem
                                                />{" "}
                                                เบอร์โต๊ะ:  {findUser(values.Retail) ? findUser(values.Retail).table : "-"}
                                            </Box>
                                            {errors.Retail && touched.Retail ? (
                                                <div style={{ color: "#FF3333" }}>{errors.Retail}</div>
                                            ) : null}
                                        </div>
                                        <div className="mt-4 col-12">
                                            <Button variant="contained"
                                                type="submit"
                                                disabled={isSubmitting}
                                                style={{
                                                    border: "2px solid transparent",
                                                    backgroundColor: "#6ab23a",
                                                    borderRadius: "5px",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    textDecoration: "none",
                                                    textTransform: "capitalize",
                                                }}>
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Container >
                </Form>)
            }
        </Formik >
    )
}

export default Setting_Product